export type ToastTone = 'success' | 'warn' | 'danger' | 'info';

export interface ToastProps {
  tone?: ToastTone;
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  /** render in flow instead of fixed bottom-right */
  inline?: boolean;
}

const DOTS: Record<ToastTone, string> = {
  success: 'var(--success)',
  warn: 'var(--amber)',
  danger: 'var(--danger)',
  info: 'var(--primary)',
};

export function Toast({ tone = 'success', title, description, actionLabel, onAction, inline = false }: ToastProps) {
  return (
    <div
      style={{
        position: inline ? 'static' : 'fixed',
        right: inline ? undefined : 20,
        bottom: inline ? undefined : 20,
        display: 'flex',
        alignItems: 'center',
        gap: 11,
        minWidth: 280,
        maxWidth: 380,
        background: 'var(--surface-2)',
        border: '1px solid var(--line-strong)',
        borderRadius: 'var(--r-lg)',
        boxShadow: 'var(--shadow-pop)',
        padding: '12px 15px',
        fontFamily: 'var(--font-body)',
        color: 'var(--text-1)',
        animation: 'tv-rise .25s cubic-bezier(.22,.61,.36,1)',
        zIndex: 60,
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: '50%', background: DOTS[tone], flexShrink: 0 }} />
      <span style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0, flex: 1 }}>
        <span style={{ fontSize: 12.5, fontWeight: 600 }}>{title}</span>
        {description && <span style={{ fontSize: 11.5, color: 'var(--text-2)', lineHeight: 1.45 }}>{description}</span>}
      </span>
      {actionLabel && (
        <span
          onClick={onAction}
          style={{ fontSize: 12, fontWeight: 600, color: 'var(--primary)', cursor: 'pointer', whiteSpace: 'nowrap' }}
        >
          {actionLabel}
        </span>
      )}
    </div>
  );
}
